import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/Layout.js"
import SEO from "../components/seo"
const PageTemplate = ({ data, pageContext: {bg} }) => {
  const featuredImage = data.wordpressPage.featured_media &&
    data.wordpressPage.featured_media.localFile &&
    data.wordpressPage.featured_media.localFile.childImageSharp

	return (


	<Layout fullMenu background={bg}>
		 <SEO
		      title={data.wordpressPage.title}
		      description={data.wordpressPage.excerpt}
	    />
	    <article id="main">
	      <header>
	        <div className="header-content">
	          {featuredImage && (
	            <div className="header-image">
	              <Img fixed={featuredImage.fixed} />
	            </div>
	          )}
	          <h2>{data.wordpressPage.title}</h2>
	        </div>
	      </header>
	      <section className="wrapper style5">
	        <div className="inner" dangerouslySetInnerHTML={{ __html: data.wordpressPage.content.replace('http://', 'https://') }} />
	      </section>
	    </article>
	  </Layout>


)}
export default PageTemplate
export const query = graphql`
  query($id: Int!) {
    wordpressPage(wordpress_id: { eq: $id }) {
      title
      excerpt
      content
      featured_media {
        localFile {
          childImageSharp {
            fixed(width: 100, height: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`